import { Component, Host, h, Prop } from '@stencil/core';
import type { Entry } from '../../../../types/site';

@Component({
  tag: 'sy-site-footer-list',
  styleUrl: './sy-site-footer-list.scss',
  shadow: true,
})
export class SySiteFooterList {
  /**
   * List title
   */
  @Prop() category: string;

  /**
   *  category's subitems list title
   */
  @Prop() subCategory: string;

  /**
   * Array of items do be displayed in list
   */
  @Prop() items: Entry[];

  render() {
    return (
      <Host>
        <div>
          <sy-text type="small">{this.category ?? '\u00A0'}</sy-text>
        </div>
        {this.subCategory && (
          <div class="subcategory">
            <sy-text type="small">{this.subCategory}</sy-text>
          </div>
        )}
        <ul class={{ sublist: this.subCategory ? true : false }}>
          {this.items.map((child) => {
            return (
              <li key={child.title}>
                <a target="_self" href={child.href}>
                  <sy-text type="small">{child.title}</sy-text>
                </a>
              </li>
            );
          })}
        </ul>
      </Host>
    );
  }
}
